import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";
import axios from "axios";
Vue.prototype.$axios = axios;

// router setup
import router from "./routes/routes"; // Importa el router, no las routes

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import Chartist from "chartist";

// Usar Plugins
Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);

Vue.prototype.$Chartist = Chartist;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router, // Usa el router importado
  data: {
    Chartist: Chartist,
  },
});